import styled, { css } from 'styled-components'
import { ifNotProp, ifProp, prop } from 'styled-tools'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'

export const TopBar = styled.ul`
  height: 40px;
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
`

export const TabItem = styled.li`
  width: 160px;
  height: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  background-color: ${colorsOptions.greys.white};
  border: 0.5px solid ${colorsOptions.greys['grey-30']};
  cursor: pointer;
  :last-child {
    border-top-right-radius: 8px;
  }
  :first-child {
    border-top-left-radius: 8px;
  }
  ${ifNotProp(
    'active',
    css`
      &:hover {
        background-color: ${prop('hoverColor', colorsOptions.greys['grey-20'])};
        color: ${prop('hoverBgColor', colorsOptions.greys['grey-100'])};
      }
    `
  )}
  ${ifProp(
    'active',
    css`
      border-bottom: 2px solid;
      border-color: ${colorsOptions.docuToolsOrange.orange};
      background-color: ${colorsOptions.docuToolsOrange['dt-10']};
      color: ${colorsOptions.docuToolsOrange.orange};
      cursor: default;
      ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
    `
  )}
  .featureAvailability {
    display: contents;
  }
`
